module.exports = __webpack_public_path__ + "media/count_volume_10.ffc00706.mp3";